var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28.7745,
    height: 28.7745,
    rx: 14.3872,
    fill: "#607D8B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4589 10.6212C16.4589 12.4123 15.0069 13.8643 13.2158 13.8643C11.4247 13.8643 9.97266 12.4123 9.97266 10.6212C9.97266 8.83007 11.4247 7.37808 13.2158 7.37808C15.0069 7.37808 16.4589 8.83007 16.4589 10.6212Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8103 15.3218C15.0802 15.2254 14.2183 15.1615 13.2158 15.1615C10.1945 15.1615 8.44966 15.7417 7.74539 16.0442C7.51157 16.1446 7.37817 16.3783 7.37817 16.6328C7.37817 19.0442 9.33304 20.9991 11.7445 20.9991H14.687C15.3542 20.9991 15.9865 20.8495 16.552 20.5819C16.1003 20.2256 15.8103 19.6733 15.8103 19.0533V15.3218Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1343 19.7019V15.1615H21.1614V19.7019H22.1343Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1885 13.2157V19.7019H19.2156V13.2157H20.1885Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2427 19.7019V16.4588H17.2698V19.7019H18.2427Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserListIcon);
export default __webpack_public_path__ + "static/media/user-list-icon.19fbc30712d6e30e40eb351f5d19881e.svg";
export { ForwardRef as ReactComponent };